import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CompaniesTable } from '../../common/types/types';

interface CompaniesState {
  dohvaceniCompanies: CompaniesTable[];
  updateTable: boolean;
}

const initialState: CompaniesState = {
  dohvaceniCompanies: [],
  updateTable: false,
};

const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setDohvaceniCompanies: (state, action: PayloadAction<CompaniesTable[]>) => {
      return { ...state, dohvaceniCompanies: action.payload };
    },
    toggleUpdateCompaniesTable(state) {
      state.updateTable = !state.updateTable;
    },
  },
});

export const { reset, setDohvaceniCompanies, toggleUpdateCompaniesTable } = companiesSlice.actions;
export default companiesSlice.reducer;
